import { S, officeOf, isToday } from '../store.js';
import { esc, statusAt, dowOf, minuteOfDay, fmtTime, $, intervals, hoursText } from '../util.js';

export function pill(st) {
  const c = { open: 'p-open', soon: 'p-soon', closed: 'p-closed', unk: 'p-unk' }[st.s];
  return `<span class="pill ${c}">${esc(st.label)}</span>`;
}

/** Office status right now (today) or at the planned arrival time. */
export function officeStatus(office, atMs) {
  if (!office?.hours) return { s: 'unk', label: 'Hours not set' };
  const t = atMs || (isToday() ? Date.now() : null);
  const min = t ? minuteOfDay(t) : 9 * 60;
  return statusAt(office.hours, dowOf(S.date), min);
}

export function statusPill(s) {
  if (s.status === 'delivered') return `<span class="pill p-done">${pickupOnly(s) ? 'Picked up' : 'Delivered'} ${esc(fmtTime(s.deliveredAt))}</span>`;
  if (s.status === 'skipped') return `<span class="pill p-skip">${pickupOnly(s) ? 'Not picked up' : 'Not delivered'}</span>`;
  return '<span class="pill p-pend">Pending</span>';
}

export function etaCell(s) {
  if (s.status !== 'pending') return '';
  const o = officeOf(s);
  if (unreachable(s)) return `${s.eta ? `<span class="mono">${esc(fmtTime(s.eta))}</span> ` : ''}<span class="pill p-closed">Can't reach while open</span>${todayHours(o)}`;
  if (!s.eta) return s.etaWarn ? `<span class="pill p-soon">${esc(s.etaWarn)}</span>` : pill(officeStatus(o));
  const st = officeStatus(o, s.eta);
  return `<span class="mono">${esc(fmtTime(s.eta))}</span> ${pill(st)}${todayHours(o)}`;
}

/** "Hours: 8 AM to 12 PM, 1 PM to 3 PM" for the day being viewed, so it's clear when an office closes. */
export function todayHours(o) {
  if (!o?.hours) return '';
  return `<div class="small muted">Hours: ${esc(hoursText(intervals(o.hours, dowOf(S.date))))}</div>`;
}

/** Case chips for a stop (try-ins tagged) plus any Pilot pickup requests. Accepts a stop or a plain list. */
export function cases(s) {
  const st = Array.isArray(s) ? { cases: s } : (s || {});
  const tri = new Set(st.tryins || []);
  const chips = (st.cases || []).map((c) => `<span class="case${tri.has(c) ? ' tryin' : ''}">${esc(c)}${tri.has(c) ? ' <b>Try-in</b>' : ''}</span>`);
  for (const p of st.pickups || []) chips.push(`<span class="case pickup"><b>Pick up</b>${p.ready ? ` ready ${esc(fmtHM(p.ready))}` : ''}${p.close ? `, by ${esc(fmtHM(p.close))}` : ''}</span>`);
  return `<div class="cases">${chips.join('') || '<span class="muted small">No case numbers</span>'}</div>`;
}
const fmtHM = (t) => { const [h, m] = t.split(':').map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`; };

/** "3 cases, 1 try-in, pickup" */
export function workSummary(s) {
  const n = (s.cases || []).length; const t = (s.tryins || []).length; const p = (s.pickups || []).length;
  const parts = [];
  if (n - t) parts.push(`${n - t} case${n - t === 1 ? '' : 's'}`);
  if (t) parts.push(`${t} try-in${t === 1 ? '' : 's'}`);
  if (p) parts.push(p === 1 ? 'pickup' : `${p} pickups`);
  return parts.join(', ') || 'No cases';
}
/** Google couldn't fit this stop in while the office is open (it keeps its place on the route). */
export const unreachable = (s) => s.status === 'pending' && (s.unreachable === true || s.etaWarn === "Can't reach while the office is open");
export const pickupOnly = (s) => !(s.cases || []).length && (s.pickups || []).length > 0;

export function modal(html) {
  $('#modalRoot').innerHTML = `<div class="scrim" data-act="closeModalBg"><div class="modal" role="dialog" aria-modal="true">${html}</div></div>`;
  const f = $('#modalRoot input:not([type=hidden]),#modalRoot select,#modalRoot textarea');
  if (f) f.focus();
}
export const closeModal = () => { $('#modalRoot').innerHTML = ''; };
export const modalOpen = () => !!$('#modalRoot').innerHTML;
